import bodybuilder from "bodybuilder";

function get_project_query (filters, size=process.env.VUE_APP_ELASTIC_TOP) {
	const query = bodybuilder().size(size).sort("dateCommande", "desc");
	for (const [filter, value] of _.entries(filters)) {
		if (!value || _.isEmpty(value)) continue;

		if (filter == "name" && !_.isEmpty(value)) {
			query.query("query_string", "query", "nom:" + value + "*");
		}

		if (filter == "bounding_box") {
			query.filter("geo_bounding_box", {
				"position.location": {
					"top_left": [value.west, value.north],
					"bottom_right": [value.east, value.south]
				}
			});
		}

		if (filter == "location") {
			query.query("query_string", "query", "adresse.ville:" + value + "*");
		}
		if (filter == "departement" && !_.isEmpty(value)) {
			query.filter("term", "geoDetails.departement.code.keyword", value);
		}

		if (filter == "consultant") {
			value = value.split('@', 1)[0];
			query.query("query_string", "query", "contributeurAdequation.email:*" + value + "*");
		}

		if ( filter == "consultant_logged_value" && !_.isEmpty(value)) {
			query.filter("term", "contributeurAdequation.email.keyword", value);
		}
	}
	//AGGR - DEPARTEMENT
	query.aggregation(
		"terms", {
			"field": "geoDetails.departement.code.keyword",
			"size": 1000
		}, 
		"departement",
		(q)=>{
			return q.aggregation("terms", {
				"field": "geoDetails.departement.label.keyword",
			}, "label")
		}
	);
	query.aggregation("terms", {
		"field": "contributeurAdequation.email.keyword",
		"size": 1000
	}, "email");
	return query;
}

function get_study_query (filters, size=process.env.VUE_APP_ELASTIC_TOP,init=false) {
	const query = bodybuilder().size(size).sort("dateCreation", "desc");
	for ( const [filter, value] of _.entries(filters) ) {
		if (!(value ===true) && (!value || _.isEmpty(value))) continue;

		if (filter == "segment_not" && !_.isEmpty(value)) {
			query.notFilter('match', 'segment.code', value)
		}
		if (filter == "segment" && !_.isEmpty(value.code)) {
			query.query('match', 'segment.code', value.code)
		}
		if (filter == "status" && !_.isEmpty(value.slug)) {
			query.filter("match", "statut.slug", value.slug);
		}
		if (filter == "type" && !_.isEmpty(value.slug)) {
			query.filter("term", "etudeType.slug.keyword", value.slug);
		}
		if (filter == "year" ) {
			query.filter("range", "dateCreation", {"gte": `${value}||/y`, "lte": `${value}||/y`, format: "yyyy"});
		}
		if (filter == "evalis") {
			query.query("query_string", "query", "evalisReference:*" + value + "*");
		}

		if (filter == "evalis_empty" && value) {
			query.filter("term", "evalisReference.keyword", "");
		}

	}
	if(init){
		query.rawOption("_source", { "includes": [ "projet.id" ] });
	}
	query.rawOption("_source", { "excludes": [ "qlikData", "etudeData", "qlikDataOld" ] });
	query.aggregation("date_histogram", {
		"field": "dateCreation",
		"interval": "year"
	}, "years");

	query.aggregation("terms", {
		"field": "evalisReference.keyword",
		"size": 1000
	}, "evalisReference");

	return query;
}

function check_study_filter(filters){
	for (const [filter, value] of _.entries(filters)) {
		if (!(value ===true) && (!value || _.isEmpty(value))) continue;

		if (filter == "segment_not" && !_.isEmpty(value)) {
			return true
		}
		if (filter == "segment" && !_.isEmpty(value.code)) {
			return true
		}
		if (filter == "status" && !_.isEmpty(value.slug)) {
			return true
		}
		if (filter == "type" && !_.isEmpty(value.slug)) {
			return true
		}
		if (filter == "year" ) {
			return true
		}
		if (filter == "evalis") {
			return true
		}
		if (filter == "evalis_empty" && value) {
			return true
		}
	}
	return false;
}

export default {
	get_project_query: get_project_query,
	get_study_query: get_study_query,
	check_study_filter: check_study_filter
};